import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const TemplateLastEditedByFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: members } = useCurrentOrganizationMembers();

    const options = useMemo(
        (): FilterMultiselectOption[] =>
            (members ?? []).map((member) => ({
                value: member.user.id,
                label: member.user.name,
                searchableLabel: `${member.user.name} ${member.user.email ?? ""}`,
            })),
        [members],
    );

    const value = filters.closeTemplateUpdatedByUserIds ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const ids = val.filter(
                        (v): v is number => typeof v === "number",
                    );
                    onChange({
                        closeTemplateUpdatedByUserIds:
                            ids.length > 0 ? ids : undefined,
                    });
                }}
                name="closeTemplateUpdatedByUserIds"
                onBlur={noop}
                searchable
            />
        </div>
    );
};
